import script from "./BaseModalStack.vue?vue&type=script&lang=js"
export * from "./BaseModalStack.vue?vue&type=script&lang=js"

import "./BaseModalStack.vue?vue&type=style&index=0&id=557b9859&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-557b9859"]])

export default __exports__